import { Designer } from './Designer.js';
import type {
    IContainer,
    IPhotoCrop,
    IProject,
    ISurface,
    IUserPhotoAsset,
} from '../common/index.js';
import { isUserPhotoAsset } from '../common/utils/index.js';
import { getSuggestedCrop } from '../crop/index.js';

export class PrintsDesigner extends Designer {

    public designProject(): IProject {
        const newSurfaces: ISurface[] = [];
        const containersSurfaces = this.project.surfaces
            .map((surface) => {
                const userPhotoAsset = surface.assets.find((asset) => isUserPhotoAsset(asset));

                return userPhotoAsset ? { container: userPhotoAsset.container, surface } : null;
            })
            .filter((item): item is { container: IContainer; surface: ISurface } => item !== null);

        for (const photo of this.photos) {
            let bestCrop: IPhotoCrop | undefined;
            let selectedSurface: ISurface | undefined;

            for (const containerSurface of containersSurfaces) {
                const crop = getSuggestedCrop(photo, containerSurface.container);

                if (crop && (!bestCrop || crop.rank > bestCrop.rank)) {
                    bestCrop = crop;
                    selectedSurface = containerSurface.surface;
                }
            }

            if (selectedSurface && bestCrop) {
                const userPhotoAsset = selectedSurface.assets.find((asset) => isUserPhotoAsset(asset)) as IUserPhotoAsset;

                userPhotoAsset.content = {
                    crop: {
                        x: bestCrop.x / photo.width,
                        y: bestCrop.y / photo.height,
                        width: bestCrop.width / photo.width,
                        height: bestCrop.height / photo.height,
                    },
                    photoId: photo.photoId,
                    source: photo.source,
                };
                newSurfaces.push(selectedSurface);
            }
        }

        return {
            ownerId: '',
            photos: this.photos,
            projectId: '',
            surfaces: newSurfaces,
            type: 'prints',
        };
    }

}
